import { LocaleContext } from '@/Contexts/LocaleContext';
import { isEmail } from '@/utils/emailUtil';
import { TextField, TextFieldProps } from '@mui/material';
import { useContext, useState } from 'react';

interface EmailProps extends Omit<TextFieldProps, 'onChange'> {
  value?: string | null;
  disableValidation?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

export function Email({ onChange, name = 'email', value = '', ...props }: EmailProps) {
  const [hasValidationError, setHasValidationError] = useState(false);
  const { translatedText } = useContext(LocaleContext);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHasValidationError(false); // Reset error state on change
    if (onChange == null) throw new Error('onChange handler is required for Email component');

    onChange(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const email = e.target.value;
    setHasValidationError(email !== '' && !isEmail(email));
  };

  const showError = !props.disabled && (props.error || hasValidationError);
  const showCharacterLimitHelper = value != null && 100 - value.length <= 0;

  const helperText =
    // create switch statement to determine helper text
    showError
      ? translatedText.contact.invalidEmail
      : showCharacterLimitHelper
        ? translatedText.myaccount.characterlimit(100)
        : props.helperText;

  return (
    <TextField
      {...props}
      type='email'
      name={name}
      value={value}
      error={props.error || showError}
      helperText={helperText}
      onChange={handleEmailChange}
      onBlur={handleBlur}
    />
  );
}
